import React from "react";
import GuideCard from "../../../../components/Universal/GuideCard.component";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import { Helmet } from "react-helmet";
import "../../../../styles/Pages/Financial/CashOutFlow/AcademicEx/AcademicEx.style.css";

const Body = ({AcademicEx}) => {

    return (
      <section className="AcademicExContainer">
      <Helmet>
        <title>Academic Ex.</title>
        <meta
          name="description"
          content="Monitor and analyze cash inflow trends and contributions."
        />
        <meta
          name="keywords"
          content="cash inflow, financial dashboard, cash flow analysis, business finance"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <PageHeader title={"Academic Ex."} />
      <div className="AcademicExGuideCardContainer">
        {AcademicEx.map((item, index) => {
          return (
            <GuideCard
              key={index}
              title={item?.title}
              description={item?.description}
              image={item?.image}
              link={item?.link}
            />
          );
        })}
      </div>
    </section>
  );
};

export default Body;
